<template>
    <div class="wrap-content customer-section">
        <div class="filter-section row-min-space">
            <div class="row">
                <div class="col-md-12">
                    <h2>All Customers</h2>
                </div>

                <div class="col-md-12 filter-all-customers">
                    <div class="row">
                        <div class="col-md-4">
                            <b-form-group>
                                <b-form-radio-group
                                    v-model="query.status"
                                    :options="filterList"
                                    buttons
                                    button-variant="outline-primary"
                                    @change="apply"
                                ></b-form-radio-group>
                            </b-form-group>
                        </div>
                        <div class="col-md-8">
                            <div class="row">
                                <div class="col-md-5">
                                    <base-search
                                        placeholder="Search"
                                        @keyword="getKeyword"
                                    ></base-search>
                                </div>
                                <!-- :class="{
                                        'col-md-3': hasScopes(
                                            'export-customer-profile'
                                        ),
                                        'col-md-6': !hasScopes(
                                            'export-customer-profile'
                                        ),
                                    }" -->
                                <div class="col-md-2">
                                    <b-form-group>
                                        <button
                                            class="btn btn-primary"
                                            type="submit"
                                            :class="
                                                loading && showPageLoader
                                                    ? 'disabled'
                                                    : ''
                                            "
                                            @click="apply"
                                        >
                                            <span class="btn-text">Apply</span>
                                            <span class="loader"></span>
                                        </button>
                                    </b-form-group>
                                </div>
                                <!-- v-if="hasScopes('export-customer-profile')" -->
                                <div
                                    class="col-md-2 text-right export-file-btn"
                                >
                                    <b-form-group>
                                        <b-button
                                            type="button"
                                            variant="secondary"
                                            class="secondary-add-btn"
                                            @click="exportRecords"
                                        >
                                            <span class="btn-text">EXPORT</span>
                                        </b-button>
                                    </b-form-group>
                                </div>
                                <div
                                    class="col-md-3 text-right export-file-btn"
                                >
                                    <!-- Using modifiers -->
                                    <b-button
                                        v-b-toggle.collapse-2
                                        :style="{ backgroundColor: '#8b6f87' }"
                                        @click="onClickButtonDropdown"
                                    >
                                        Show Exports
                                    </b-button>

                                    <!-- Element to collapse -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <b-collapse id="collapse-2">
                    <b-table
                        v-if="data_downloads.length"
                        :items="data_downloads"
                        :fields="fields_downloads"
                        no-local-sorting
                        @sort-changed="sortingChanged"
                    >
                        <template slot="updatedAt" slot-scope="data">
                            <span>{{
                                data.item.updatedAt
                                    | moment('MMMM Do YYYY, h:mm:ss a')
                            }}</span>
                        </template>
                        <template slot="fileName" slot-scope="data">
                            <span>{{
                                data.item.exportDocumentTypeId ==
                                '6266de273902cdae4c71337d'
                                    ? 'Export Name Screening Hits Data'
                                    : 'Export All Customers'
                            }}</span>
                        </template>
                        <template slot="fileName" slot-scope="data">
                            <b-link
                                :href="`${APP_URL}files/${
                                    data.item.exportDocumentTypeId ==
                                    '6266de273902cdae4c71337d'
                                        ? 'reports-bulk-fetch'
                                        : 'export'
                                }/${data.item.fileName}`"
                                >Download</b-link
                            >
                        </template>
                    </b-table>
                    <b-card v-else>
                        <h2>
                            There are no downloadable files ready for this data
                            segment, please request a file from the export
                            button
                        </h2>
                    </b-card>
                </b-collapse> -->
                <b-collapse id="collapse-2">
                    <b-table
                        v-if="data_downloads.length"
                        :items="data_downloads"
                        :fields="fields_downloads"
                        no-local-sorting
                        @sort-changed="sortingChanged"
                    >
                        <template slot="updatedAt" slot-scope="data">
                            <span>{{
                                data.item.updatedAt
                                    | moment('MMMM Do YYYY, h:mm:ss a')
                            }}</span>
                        </template>
                        <template slot="documentType" slot-scope="data">
                            <span
                                v-if="
                                    data.item.exportDocumentTypeId ==
                                    '6266de273902cdae4c71337d'
                                "
                                class="d-flex"
                            >
                                <pdf-icon style="width: 24px"></pdf-icon>
                            </span>
                            <span v-else>
                                <excel-icon style="width: 24px"></excel-icon>
                            </span>
                        </template>
                        <template slot="documentName" slot-scope="data">
                            <span
                                v-if="
                                    data.item.exportDocumentTypeId ==
                                    '6266de273902cdae4c71337d'
                                "
                                class="d-flex"
                            >
                                Export Name Screening Hits Data
                            </span>
                            <span v-else> Export All Customers </span>

                            <!-- <span>{{
                                data.item.exportDocumentTypeId ==
                                '6266de273902cdae4c71337d'
                                    ? 'Export Name Screening Hits Data'
                                    : 'Export All Customers'
                            }}</span> -->
                        </template>
                        <template slot="fileName" slot-scope="data">
                            <b-link
                                :href="`${APP_URL}files/${
                                    data.item.exportDocumentTypeId ==
                                    '6266de273902cdae4c71337d'
                                        ? 'reports-bulk-fetch'
                                        : 'export'
                                }/${data.item.fileName}`"
                                :disabled="
                                    data.item.status == 'completed'
                                        ? false
                                        : true
                                "
                                >{{
                                    data.item.status == 'completed'
                                        ? 'Download'
                                        : 'Document is in process'
                                }}</b-link
                            >
                        </template>
                    </b-table>
                    <b-card v-else>
                        <h2>
                            There are no downloadable files ready for this data
                            segment, please request a file from the export
                            button
                        </h2>
                    </b-card>
                </b-collapse>
            </div>
        </div>

        <div
            :class="[
                'table-section',
                'table-min-width',
                {
                    'overflow-hidden': !data.length && !showPageLoader,
                },
            ]"
        >
            <b-table
                :items="data"
                :fields="fields"
                no-local-sorting
                @sort-changed="sortingChanged"
            >
                <template slot="pictureURL" slot-scope="data">
                    <div class="profile-area">
                        <router-link
                            :to="{
                                name: 'customer-information',
                                params: {
                                    id: data.item._id,
                                },
                            }"
                        >
                            <div
                                v-if="data.item.pictureURL"
                                v-authenticated-image="data.item.pictureURL"
                                class="profile-pic"
                            ></div>
                        </router-link>
                    </div>
                </template>

                <template slot="idenfoId" slot-scope="data">
                    <div class="customer-link">
                        <router-link
                            :to="{
                                name: 'customer-information',
                                params: {
                                    id: data.item._id,
                                },
                            }"
                        >
                            {{ data.item.idenfoId }}
                        </router-link>
                    </div>
                </template>

                <template slot="fullName" slot-scope="data">
                    <div class="action-flex">
                        <router-link
                            :to="{
                                name: 'customer-information',
                                params: {
                                    id: data.item._id,
                                },
                            }"
                        >
                            <span>
                                {{ data.item.fullName | titleCase }}
                            </span>
                        </router-link>
                    </div>
                </template>

                <!-- Join Date -->
                <template slot="createdAt" slot-scope="data">
                    {{ data.item.createdAt | moment('MMM D, YYYY h:mm a') }}
                </template>

                <template slot="status" slot-scope="data">
                    <base-status :status-type="data.item.status"></base-status>
                </template>

                <template slot="action" slot-scope="data">
                    <div class="action-review">
                        <base-action
                            icon="icon-eye-view"
                            label="View Profile"
                            @click="
                                $router.push({
                                    name: 'customer-information',
                                    params: {
                                        id: data.item._id,
                                    },
                                })
                            "
                        ></base-action>
                    </div>
                </template>
            </b-table>
            <!-- When data is loading -->
            <base-table-spinner
                v-if="!data.length && showPageLoader"
            ></base-table-spinner>
            <!-- When record not found -->
            <base-no-record-found
                v-if="!data.length && !showPageLoader"
            ></base-no-record-found>
        </div>

        <base-records
            path="customers/"
            :query="query"
            :reset="reset"
            :show-pagination="true"
        ></base-records>

        <export-process-popup
            export-graph-id="stats-charts"
            file-name="Stats.pdf"
            :graph-ids="graphIds"
            :query="query"
        ></export-process-popup>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import exportProcessPopup from '@/components/popups/ExportProcessPopup.vue'
import request from '@/utils/request'
import excelIcon from '@/components/icons/ExcelIcon.vue'
import pdfIcon from '@/components/icons/PdfIcon.vue'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        exportProcessPopup,
        excelIcon,
        pdfIcon,
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            APP_URL: process.env.VUE_APP_API_URL,
            graphIds: [
                'customer-by-age',
                'customers-by-gender',
                'customers-by-work-type',
                'customers-account-by-month',
                'customers-by-industry',
                'customers-by-nationality',
                'customers-by-residence',
            ],
            data_downloads: [],
            toggle: false,
            fields_downloads: {
                updatedAt: {
                    label: 'Created At',
                    sortable: true,
                    tdAttr: {
                        dataname: 'updatedAt',
                    },
                },
                documentType: {
                    label: 'Document Type',
                    sortable: true,
                    tdAttr: {
                        dataname: 'documentType',
                    },
                },
                documentName: {
                    label: 'Document Name',
                    sortable: true,
                    tdAttr: {
                        dataname: 'documentName',
                    },
                },
                fileName: {
                    label: 'Download Link',
                    sortable: true,
                    tdAttr: {
                        dataname: 'fileName',
                    },
                },
            },
            fields: {
                pictureURL: {
                    label: '',
                    tdClass: 'profile-absolute',
                    tdAttr: {
                        dataname: '',
                    },
                },
                idenfoId: {
                    label: 'CUSTOMER',
                    sortable: true,
                    tdAttr: {
                        dataname: 'Customer',
                    },
                },
                fullName: {
                    label: 'FULL NAME',
                    sortable: true,
                    tdAttr: {
                        dataname: 'Full Name',
                    },
                    tdClass: 'email-truncate',
                },
                nationality: {
                    key: 'basicInfo.nationality',
                    label: 'NATIONALITY',
                    sortable: true,
                    tdAttr: {
                        dataname: 'nationality',
                    },
                },
                countryOfResidence: {
                    key: 'basicInfo.countryOfResidence',
                    label: 'RESIDENCE',
                    sortable: true,
                    tdAttr: {
                        dataname: 'countryOfResidence',
                    },
                },
                createdAt: {
                    label: 'REGISTRATION DATE',
                    sortable: true,
                    tdAttr: {
                        dataname: 'createdAt',
                    },
                },
                status: {
                    label: 'STATUS',
                    sortable: true,
                    tdClass: 'text-center status-absolute-pos',
                    thClass: 'text-center',
                    tdAttr: {
                        dataname: 'status',
                    },
                },
                action: {
                    label: 'Actions',
                    tdClass: 'w-150px',
                    tdAttr: {
                        dataname: 'Actions',
                    },
                },
            },
            path: 'customers/',
            filterList: [
                { text: 'All', value: null },
                { text: 'Pending Review', value: 'pending' },
                { text: 'Approved', value: 'approved' },
                { text: 'Rejected', value: 'rejected' },
            ],
            query: {
                startAt: 1,
                keyword: '',
                perPage: 10,
                status: null,
                sortBy: 'idenfoId',
                sortOrder: 'desc',
            },
            reset: new Date().getTime(),
            id: null,
            cancelUrl: 'customers/cancel-export',
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters([
            'data',
            'showPageLoader',
            'loading',
            'dataSegmentId',
            'hasScopes',
        ]),
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {}, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        // console.log("all customer", this.$store.getters.getField('pagination'))
        console.log('Hello from data', this.data)
        localStorage.setItem('goBackUrl', this.$route.name)
        let queryData = JSON.parse(localStorage.getItem('queryData'))
        if (queryData) {
            Object.assign(this.query, queryData)
            localStorage.removeItem('queryData')
        }
    }, // End of Component > watch

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        /**
         *
         * @return {void}
         */
        getKeyword(val) {
            this.query.keyword = val
        }, // End of getKeyword() method

        async onClickButtonDropdown() {
            this.toggle = !this.toggle
            if (this.toggle) {
                console.log('Callin API')
                let { data } = await request.get(
                    `customers/getExportPdfInfo/${this.dataSegmentId}`,
                    null
                )
                this.data_downloads = data
                console.log(data)
            }
        },

        /**
         *
         * @return {void}
         */
        apply() {
            this.$store.commit('setLoading', true)
            this.reset = new Date().getTime()
        }, // End of apply() method

        /**
         *
         * @return {void}
         */
        selectedRecord(record) {
            this.$store.commit('setItem', record)
        }, // End of selectedRecord() method

        /**
         *
         * @return {void}
         */
        sortingChanged(ctx) {
            // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
            this.query.sortBy = ctx.sortBy

            // ctx.sortDesc ==> true if sorting descending, false otherwise
            this.query.sortOrder = ctx.sortDesc ? 'desc' : 'asc'

            this.apply()
            this.$store.commit('setLoading', false)
        }, // End of sortingChanged() method

        /**
         *
         * @return {void}
         */
        async exportRecords() {
            try {
                // this.query.dataSegmentId = this.dataSegmentId

                // let { data } = await request.post('customers/export', null, {
                //     params: this.query,
                // })

                // console.log('data  ' + JSON.stringify(data))

                // this.id = data.data.id
                this.$bvModal.show('export-process-popup')
                // this.$toasted.show(data.message, {
                //     type: 'success',
                // })
            } catch (error) {
                // console.log(error, 'error')
            }
        }, // End of exportRecords() method
    }, // End of Component > mounted
} // End of export default
</script>
